<template>
  <div>
    <div id="bk1" style="display: none" class="bk1"></div>
    <div id="openImg" style="display: none" class="openImg">
      <div class="bn" @click="open()">
        <img src="../assets/img/icon_close@2x.png" alt="" />
      </div>
      <div class="three">
        <img :src="this.img" alt="" />
        <div class="title">{{ this.title }}</div>
        <div class="content">{{ this.content }}</div>
      </div>
    </div>

    <div class="bk">
      <div>资质中心</div>
    </div>
    <div class="two">
      <span>
        <router-link :to="{ path: '/qualification' }"
          ><p>行业协会</p></router-link
        ></span
      >
      <span
        ><router-link :to="{ path: '/qualification2' }"
          ><p>工程资质</p></router-link
        ></span
      >
      <span
        ><router-link :to="{ path: '/qualification4' }"
          ><p>集团荣誉</p></router-link
        ></span
      >
      <span class="check"
        ><router-link :to="{ path: '/qualification3' }"><p>其他</p></router-link
        ><i></i
      ></span>
    </div>
    <div class="qualification">
      <ul>
        <li @click="selectBySub('其他')">其他</li>
      </ul>
      <!-- <div class="introduce">
        其他行业协会，是指非安防、智慧交通分类的协会，行业协会的任务和关注领域因行业而异，可以涵盖从医疗保健、科技、教育、金融到制造业等广泛领域。它们的存在有助于塑造行业未来，维护声誉，推动可持续发展，为成员提供支持和竞争优势，以满足市场需求和社会期望。
      </div> -->
      <div class="topImg" v-for="person in arr" :key="person.resourceId">
        <div class="img1">
          <!-- <img src="../assets/img/fa1936b4b7d3f69c4f078927c377a37.jpg" alt=""> -->
          <img
            @click="open(person.imgPath, person.title)"
            :src="person.imgPath"
            alt=""
          />
        </div>
        <div class="content">{{ person.title }}</div>
      </div>
    </div>
    <div class="bm">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn"
          >粤ICP备17113788号</a
        ></span
      >
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteLeave (to, from, next) {
    // 将当前滚动位置存储在 Vuex store 或 localStorage 中
    const scrollPosition = window.scrollY
    localStorage.setItem('scrollPosition', scrollPosition)
    next()
  },

  name: 'qualification3',
  data () {
    return {
      content: '',
      arr: [],
      status: 1,
      type: 3,
      img: '',
      title: ''
    }
  },
  mounted () {
    this.select()
    this.selectBySub('其他')
  },
  methods: {
    open (img, title) {
      //跳转当前页面顶部

      //   let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      //         if (scrollTop > 0) {
      //             document.documentElement.scrollTop = document.body.scrollTop = 0
      //   }
      this.img = img
      this.title = title
      var nowStatus = document.getElementById('bk1')
      var bkStatus = document.getElementById('openImg')
      if (nowStatus.style.display == 'none') {
        nowStatus.style.display = 'block'
        bkStatus.style.display = 'block'
        this.scrollPosition = window.scrollY
        window.scrollTo(0, 0)
      } else {
        nowStatus.style.display = 'none'
        bkStatus.style.display = 'none'
        console.log(this.scrollPosition)
        window.scrollTo(0, this.scrollPosition)
      }
    },
    select () {
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 100,
            category: '其他'
          }
        })
        .then(res => {
          this.arr = res.data.data
          this.$nextTick(() => {
            const storedScrollPosition = localStorage.getItem('scrollPosition')
            if (storedScrollPosition) {
              window.scrollTo(0, parseInt(storedScrollPosition))
              localStorage.removeItem('scrollPosition')
            }
          })
        })
    },
    selectBySub (gopath) {
      this.arr = []
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 100,
            category: gopath
          }
        })
        .then(res => {
          this.arr = res.data.data
        })
    },
    selectBySub2 (category) {
      this.arr = []
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 1,
            category: category
          }
        })
        .then(res => {
          this.arr = res.data.data
        })
    }
  }
}
</script>

<style scoped>
.qualification {
  min-height: 1000px;
}
.bk1 {
  position: absolute;
  width: 100vw;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.77);
  display: none;
}
.openImg {
  position: absolute;
  z-index: 12;
  display: none;
  top: 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.openImg .bn {
  width: 92vw;
  height: 4.2667vw;
  float: right;
  margin: 4.2667vw auto 0;
}
.openImg .bn img {
  width: 4.2667vw;
  height: 4.2667vw;
  float: right;
  background-image: url('../assets/img/icon_close.svg');
  background-size: 100% 100%;
}
.openImg .three {
  margin-top: 13.3333vw;
  width: 92vw;
  height: 76.6667vw;
  background-color: #ffff;
}
.openImg .three img {
  display: block;
  width: 84vw;
  height: 56vw;
  margin-left: 4vw;
  padding-top: 4vw;
}
.openImg .three .title {
  margin-left: 4vw;
  margin-top: 5.3333vw;
  color: #1d1e20;
  letter-spacing: 0.2vw;
  line-height: 5.3333vw;
  font-size: 3.7333vw;
  margin-bottom: 1.6vw;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.openImg .three .content {
  width: 84vw;
  margin-left: 4vw;
  overflow: hidden;
}
.topImg {
  width: 92vw;
  height: 64vw;
  margin: 4vw auto 0px;
}
.topImg .img1 img {
  position: absolute;
  display: block;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 80%;
  object-fit: contain;
}

.topImg .img1 {
  position: relative;
  width: 92vw;
  height: 53.3333vw;
  background: #f1f4fb;
  box-shadow: 0px 0px 5px 0px rgba(206, 206, 206, 0.5);
}
.topImg .content {
  text-align: center;
  color: #000000;
  opacity: 0.58;
  font-size: 3.7333vw;
  letter-spacing: 0.1333vw;
  height: 10.6667vw;
  line-height: 10.6667vw;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0px 0px 5px 0px rgba(206, 206, 206, 0.5);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bk {
  position: relative;
  width: 100vw;
  height: 87.3333vw;
  background-image: url(../assets/img/资质中心_banner_mob.png);
  background-size: 100% 100%;
  background-size: 100% 100%;
}
.bk div {
  position: absolute;
  top: 38.9333vw;
  left: 34.2667vw;
  font-family: AlibabaPuHuiTiB;
  color: #ffffff;
  line-height: 8.6667vw;
  letter-spacing: 1.6vw;
  font-size: 6.4vw;
}
.two {
  width: 100vw;
  height: 10.6667vw;
  border-bottom: 1px solid #efeff2;
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
}
.two span {
  position: relative;
  display: inline-block;
  float: left;
  width: 33.3333vw;
  height: 10.6667vw;
  text-align: center;
  line-height: 10.6667vw;
  font-size: 3.2vw;
}
.two span p {
  color: rgba(0, 0, 0, 0.3);
  font-size: 3.2vw;
}
.two .check p {
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #140047;
  font-size: 3.2vw;
}

.check i {
  position: absolute;
  text-align: center;
  position: absolute;
  left: 9.6vw;
  bottom: 0px;
  width: 6.4vw;
  height: 0.2667vw;
  background-color: #140047;
  border-radius: 0.2667vw;
}

ul {
  display: block;
  margin-top: 4vw;
  width: 100vw;
  height: 8vw;
  margin-bottom: 6.6667vw;
}

ul li {
  display: inline-block;
  float: left;
  margin-left: 4vw;
  width: 26.6667vw;
  height: 8vw;
  text-align: center;
  line-height: 8vw;
  background-color: #140047;
  border-radius: 4vw;
  color: #ffffff;
  font-size: 3.2vw;
}
.introduce {
  margin: 0 auto;
  width: 89.3333vw;
  /* height: 16vw; */
  height: 30vw;
  font-size: 3.2vw;
  text-align: center;
  color: #140047;
  opacity: 0.72;
  line-height: 5.3333vw;
}
</style>



// WEBPACK FOOTER //
// src/components/qualification3.vue